import { getDeltas, isBasePeriod } from '../../../utils/dataUtils';
const getFormattedGrossProfitData = (res) => {
    const grossProfitArray = res?.grossProfit || [];
    const baseGrossProfit = grossProfitArray.find(({ comparisonPeriod }) => isBasePeriod(comparisonPeriod));
    const grossProfit = baseGrossProfit?.profitBreakdown?.grossProfit || 0;
    const deltas = getDeltas(grossProfitArray);
    const lastUpdatedUTC = res?.lastUpdatedUTC || '';
    return {
        deltas,
        grossProfit,
        lastUpdatedUTC,
    };
};
export default getFormattedGrossProfitData;
